import deliveryProgramParameterApi from "@/api/delivery-program/deliveryProgramParameterApi";

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async fetch({dispatch}, {deliveryProgramId}) {
      try {
        const response = await deliveryProgramParameterApi.fetch(deliveryProgramId);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async update({dispatch}, {deliveryProgramId, form}) {
      try {
        await deliveryProgramParameterApi.update(deliveryProgramId, form);
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
